export const showDistrict = [140, 161, 66];
export const showTerritories = [140, 161, 66];
export const showSamTerritories = [140, 161, 66];
export const hideDistrict = [140, 161, 66, 97];

export const notes = {
    140: [
        'CTR % calculated based on the unique impressions given a hyper targeted journey flow orchestration',
    ],
    default: [
        'CTR % calculated based on the unique impressions given a hyper targeted journey flow orchestration',
    ],
};
